import React from 'react'

const Loader = () => {
  return (
    <div className="w-full min-h-screen bg-[#131517] text-white">
      <img src="/images/loader.svg" className="w-[30%] h-auto" />
    </div>
  )
}

export default Loader
